"use client";

import HelpConsumerPage from "@components/help/HelpConsumerPage";

export default function Help() {
  return <HelpConsumerPage />;
}
